import { render, staticRenderFns } from "./BiographyForm.vue?vue&type=template&id=7d26c071"
import script from "./BiographyForm.vue?vue&type=script&lang=js"
export * from "./BiographyForm.vue?vue&type=script&lang=js"
import style0 from "./BiographyForm.vue?vue&type=style&index=0&id=7d26c071&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports